<template>
  <div
    class="lds-dual-ring"
    :style="{ '--spinner-color-1': color1, '--spinner-color-2': color2 }"
  />
</template>

<script>
export default {
  props: {
    color1: {
      type: String,
      default: 'currentColor',
    },
    color2: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>

<style scoped>
.lds-dual-ring {
  display: inline-block;
  width: 24px;
  height: 24px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 24px;
  height: 24px;
  margin: 0;
  border-radius: 50%;
  border: 2px solid var(--spinner-color-1);
  border-color: var(--spinner-color-1) transparent var(--spinner-color-2) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
